<template lang="pug">
#admin_container.container-small
  h1#container_title 맥주 레시피 관리
  .container_wr
    #s41.sub
      .inner
        .total_board_view_wrap.board_table 
          .tbl_view_head
            .tit {{res.KR_NAME}}
            .info
              dl
                dt 등록일
                dd {{res.RGS_TIME}}
          #bo_v_con
            table.guest_table.req_table
              colgroup
                col(width='120')
                col(width='160')
                col(width='120')
                col
              tbody
                tr
                  th 한글 제목
                  td(colspan="7") {{res.KR_NAME}}
                tr
                  th 영어 제목
                  td(colspan="7") {{res.EN_NAME}}
                tr
                  th 맥주 번호
                  td(colspan="7") {{res.BEER_NUM}}
                tr
                  th ABV
                  td(colspan="7") {{res.ABV}}%
                tr
                  th IBU
                  td(colspan="7") {{res.IBU}}
                tr
                  th Aroma
                  td(colspan="7") {{res.AROMA}}
                tr
                  th 어울리는 음식
                  td(colspan="7") {{res.FOOD}}
                tr
                  th 한 줄 설명
                  td(colspan="7") {{res.SIMPLE_EXPLAIN}}
                tr
                  th 자세한 설명
                  td(colspan="7") {{res.DETAILED_EXPLAIN}}
                tr
                  th 어울리는 음식
                    br
                    | (영문)
                  td(colspan="7") {{res.EN_FOOD}}
                tr
                  th 한 줄 설명
                    br
                    | (영문)
                  td(colspan="7") {{res.EN_SIMPLE_EXPLAIN}}
                tr
                  th 자세한 설명
                    br
                    | (영문)
                  td(colspan="7") {{res.EN_DETAILED_EXPLAIN}}
                tr
                  th 리스트 이미지
                  td.list_td(colspan="3")
                    p
                      img.list_img(:src='res.LIST_IMG')
                  th 상세 이미지
                  td(colspan="3")
                    p
                      img(:src='res.DETAILED_IMG')
          .board_button
            a(@click='$_goTo({name: "beer-admin"})') 목록
            a(@click='$_goTo({name: "beer-edit-admin", params: { idx: args.num }})') 수정
            a(@click='delData()') 삭제
            a.newb(@click='$_goTo({name: "beer-write-admin"})') 새글쓰기
          .table-view-nav
            ul
              li(v-if="nextprev.length > 0 && nextprev[0].idx !== 0")
                a.next(@click='$_goTo({name: "beer-detail-admin", params: { idx: nextprev[0].idx }})')
                  span.nav-title.one-ico
                    span {{nextprev[0].kr_name}}
                  em
                    img(:src='require("../../../assets/images/nextup.png")' alt='이전글')
                    |  이전글
              li(v-if="nextprev.length > 0 && nextprev[1].idx !== 0")
                a.prev(@click='$_goTo({name: "beer-detail-admin", params: { idx: nextprev[1].idx }})')
                  em
                    img(:src='require("../../../assets/images/prevdown.png")' alt='다음글') 
                    |  다음글
                  span.nav-title.one-ico
                    span {{nextprev[1].kr_name}}
</template>

<script>
export default {
  components: {},
  data() {
    return {
      args: {
        num: this.$route.params.idx,
      },
      res: {},
      nextprev: [],
      checked: [],
      flagData: {
        editFlag: false,
        allChecked: false,
        descList: true,
      },
    };
  },
  computed: {},
  methods: {
    async getData() {
      await this.$_admin_get('admin/beer/detail', this.args)
        .then(res => {
          this.res = res.data.res[0];
        })
        .catch(() => {});
    },
    async getNextPrev() {
      await this.$_admin_get('admin/beer/nextprev', {
        idx: this.args.idx,
      })
        .then(res => {
          this.nextprev = res.data.res;
        })
        .catch(() => {});
    },
    delData() {
      this.$_axios('PUT', 'admin/beer/del', {
        id: this.args.idx,
      })
        .then(() => {
          alert('삭제되었습니다.');
          this.$_goTo({ name: 'beer-admin' });
        })
        .catch(() => {});
    },
  },
  beforeMount() {
    this.args.idx = this.$route.params.idx;
  },
  mounted() {
    this.getData();
    this.getNextPrev();
  },
  created() {},
};
</script>

<style scoped>
@import '../../../assets/css/admin.css';
@import '../../../assets/css/board.css';
.board_list {
  clear: both;
  width: 100%;
  margin: 16px 0;
  border-top: 1px solid #aaa;
  border-bottom: 1px solid #aaa;
  border-top: 2px solid #1f1f1f;
}
.board_list th {
  background: #fafafa;
  font-weight: normal;
  text-align: center;
  border-bottom: 1px solid #e8e8e8;
  height: 46px;
  color: #333;
}
.board_list td.subject {
  text-align: left;
}
.board_list td.subject a {
  margin-left: 20px;
}
.board_list td {
  border-bottom: 1px solid #eee;
  height: 40px;
  text-align: center;
}
table td {
  line-height: 22px;
}
#s41.sub {
  padding: 0;
  padding-top: 30px;
}

.edit_btn {
  margin-top: 50px;
}
.board_button {
  clear: both;
  text-align: right;
  margin-bottom: 10px;
}
.board_button a {
  font-size: 13px;
  display: inline-block;
  padding: 10px 25px;
  border: 1px solid #ddd;
  line-height: 100%;
  margin-left: 5px;
  background: #fff;
}
.board_button a.newb {
  background: #2c2c2c;
  color: #fff;
  cursor: pointer;
}
em img {
  margin-right: 13px;
}
.list_img {
  margin-top: 10px;
}
.list_td {
  border-right: 1px solid #e8e8e8;
}
</style>
